import {
  AdditionalTransactionDataValue,
  AdyenCredentialData,
  BraintreeCredentialData,
  ExpressCredentialData,
  FiservCredentialData,
  MaverickCredentialData,
  PaymentCredentialData,
  PayrixCredentialData,
  RaftCredentialData,
  StripeCredentialData,
  VapCredentialData,
  WpgCredentialData,
} from './types';

export const defaultPaymentCredentialSharingValue = {
  panSharingEnabled: false,
  networkTokenSharingEnabled: false,
};

export const defaultAdditionalTransactionDataValue: AdditionalTransactionDataValue = {
  levelTwo: false,
  levelThree: false,
};

export type PspInputForm<T extends PaymentCredentialData> = {
  title: string;
  fields: {
    name: keyof T;
    label: string;
    disabled?: boolean;
  }[];
};

export const wpgInputForm: PspInputForm<WpgCredentialData> = {
  title: 'Worldwide Payment Gateway (WPG)',
  fields: [
    { name: 'user_name', label: 'Username' },
    { name: 'password', label: 'Password' },
    { name: 'merchant_code', label: 'MerchantCode' },
  ],
};

export const adyenInputForm: PspInputForm<AdyenCredentialData> = {
  title: 'Adyen',
  fields: [
    { name: 'api_key', label: 'ApiKey' },
    { name: 'merchant_account', label: 'MerchantAccount' },
  ],
};

export const fiservInputForm: PspInputForm<FiservCredentialData> = {
  title: 'Fiserv',
  fields: [
    { name: 'api_key', label: 'ApiKey' },
    { name: 'secret', label: 'Secret' },
    { name: 'merchant_id', label: 'MerchantId' },
    { name: 'terminal_id', label: 'TerminalId' },
  ],
};

export const braintreeInputForm: PspInputForm<BraintreeCredentialData> = {
  title: 'Braintree',
  fields: [
    { name: 'public_key', label: 'PublicKey' },
    { name: 'private_key', label: 'PrivateKey' },
    { name: 'merchant_account_id', label: 'MerchantAccountId' },
  ],
};

export const expressInputForm: PspInputForm<ExpressCredentialData> = {
  title: 'Express',
  fields: [
    { name: 'acceptor_id', label: 'AcceptorID' },
    { name: 'account_id', label: 'AccountID' },
    { name: 'account_token', label: 'AccountToken' },
    { name: 'terminal_id', label: 'Terminal ID' },
  ],
};

export const raftInputForm: PspInputForm<RaftCredentialData> = {
  title: 'Raft',
  fields: [
    { name: 'merchant_id', label: 'Merchant ID' },
    { name: 'bank_terminal_id', label: 'STP Terminal ID' },
    { name: 'bank_id', label: 'STP Bank ID' },
  ],
};

export const stripeInputForm: PspInputForm<StripeCredentialData> = {
  title: 'Stripe',
  fields: [
    { name: 'connect_id', label: 'ConnectId' },
    { name: 'api_key', label: 'API_key', disabled: true },
  ],
};

export const vapInputForm: PspInputForm<VapCredentialData> = {
  title: 'VAP',
  fields: [
    { name: 'username', label: 'Username' },
    { name: 'password', label: 'Password' },
    { name: 'merchant_id', label: 'Merchant ID' },
  ],
};

export const payrixInputForm: PspInputForm<PayrixCredentialData> = {
  title: 'Payrix',
  fields: [
    { name: 'api_key', label: 'ApiKey' },
    { name: 'merchant_id', label: 'Merchant Id' },
  ],
};

export const maverickInputForm: PspInputForm<MaverickCredentialData> = {
  title: 'Maverick',
  fields: [
    { name: 'access_token', label: 'AccessToken' },
    { name: 'terminal_id', label: 'Terminal Id' },
  ],
};

export const pspInputForms = {
  WPG: wpgInputForm,
  Adyen: adyenInputForm,
  Fiserv: fiservInputForm,
  Braintree: braintreeInputForm,
  Express: expressInputForm,
  RAFT: raftInputForm,
  Stripe: stripeInputForm,
  VAP: vapInputForm,
  Payrix: payrixInputForm,
  Maverick: maverickInputForm,
} as const;
